import React from 'react'
import Dropdown from 'components/common/dropdowns/Dropdown'
import colors from 'utility/colors'
import { usePartnerCategories } from 'hooks/api/partner/usePartnerCategories'
import FormLabel from 'components/common/forms/elements/FormLabel'

export const PartnerCategoriesDropdown = ({
	title = 'Select a Category',
	onSelect,
	value,
	disabled = false,
	labelStyle = {},
	style = {},
}) => {
	const { data: categories } = usePartnerCategories()

	const defaultLabelStyle = {
		color: colors.GRAY,
		fontWeight: 'bold',
		fontSize: '14px',
		marginBottom: 7,
	}

	const selectedValue = categories?.find((category) => category.id === value)

	return (
		<div style={style}>
			<FormLabel style={{ ...defaultLabelStyle, ...labelStyle }}>PARTNER CATEGORY</FormLabel>
			<Dropdown
				cardStyle={{ width: '100%', maxHeight: 300, overflowY: 'auto' }}
				style={{ width: '100%', height: '100%' }}
				color={colors.BLACK}
				onSelect={onSelect}
				buttonStyle={{
					backgroundColor: colors.WHITE,
					borderColor: colors.WHITE,
				}}
				disabled={disabled}
				defaultTitle={title}
				options={categories?.map((category) => {
					return {
						title: category.name,
						data: category,
						onClick: onSelect,
					}
				})}
			>
				{selectedValue?.name || title}
			</Dropdown>
		</div>
	)
}
